"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiInputBase-root": {
      fontFamily: "Akkurat, sans-serif",
      lineHeight: "1.25",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0"
    },
    "& .MuiFormHelperText-root": {
      fontFamily: "Akkurat, sans-serif"
    }
  },
  startAdornment: {
    marginTop: theme.spacing(-1.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1)
  },
  textPrefix: {
    fontSize: "14px",
    color: theme.palette.text.secondary
  },
  iconPrefix: {},
  iconPrefixLabel: {
    marginLeft: theme.spacing(4.5)
  }
}));

const AutocompleteBase = (_ref) => {
  let _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      id = _ref.id,
      icon = _ref.icon,
      prefix = _ref.prefix,
      label = _ref.label,
      helperText = _ref.helperText,
      placeholder = _ref.placeholder,
      value = _ref.value,
      options = _ref.options,
      multiple = _ref.multiple,
      groupBy = _ref.groupBy,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "id", "icon", "prefix", "label", "helperText", "placeholder", "value", "options", "multiple", "groupBy", "onChange"]);

  const classes = useStyles();
  let selected = value && options.filter(option => option.value == value);

  if (!multiple && selected.length) {
    selected = selected[0];
  }

  let iconPrefix, textPrefix;

  if (icon) {
    iconPrefix = _react.default.createElement(_Icon.default, {
      className: classes.iconPrefix
    }, icon);
  }

  if (prefix) {
    textPrefix = _react.default.createElement("b", {
      className: classes.textPrefix
    }, prefix);
  }

  let startAdornment;

  if (iconPrefix || textPrefix) {
    startAdornment = _react.default.createElement("div", {
      className: classes.startAdornment,
      position: "start"
    }, iconPrefix, textPrefix);
  }

  return _react.default.createElement(_Autocomplete.default, _extends({}, props, {
    id: id,
    options: options,
    groupBy: groupBy,
    value: selected,
    getOptionSelected: (option, value) => option.value === value,
    getOptionLabel: option => options && option.label || "",
    onChange: onChange,
    renderInput: params => _react.default.createElement(_TextField.default, _extends({}, params, {
      className: classes.root,
      helperText: helperText,
      label: label,
      variant: variant,
      placeholder: placeholder,
      fullWidth: true,
      InputLabelProps: _extends({}, params.InputLabelProps, {
        className: iconPrefix && classes.iconPrefixLabel
      }),
      InputProps: _extends({}, params.InputProps, {
        startAdornment: startAdornment
      })
    }))
  }));
};

var _default = AutocompleteBase;
exports.default = _default;
module.exports = exports.default;